<div class="igntr-theme flex-1 bg-[var(--background-color)]">
  <div
    class="max-w-[1180px] mx-auto px-[16px] py-[16px] md:px-[40px] md:py-[24px]"
  >
    <form
      [formGroup]="editForm"
      (ngSubmit)="onSubmit()"
      enctype="multipart/form-data"
    >
      <div class="flex items-end justify-between gap-3 mb-3">
        <app-page-hero [title]="'createDocumentType'"></app-page-hero>
        <button
          type="submit"
          class="shrink-0 px-3.5 h-9 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium"
        >
          {{ "save" | transloco }}
        </button>
      </div>

      <div class="rounded-xl border !border-slate-200/70 bg-white">
        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">
              {{ "name" | transloco }}
            </span>
          </div>
          <div [appValidateState]="editForm.get('name')">
            <input
              id="name"
              formControlName="name"
              type="text"
              class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
              placeholder="{{ 'name' | transloco }}"
              autocomplete="off"
              (keydown.enter)="$event.preventDefault()"
            />
          </div>
        </div>

        <div
          class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0 flex items-center gap-2"
        >
          <p-toggleswitch formControlName="isShownOnSideMenu" />
          <span class="text-[14px] font-medium !text-slate-700">
            {{ "showOnSidebar" | transloco }}
          </span>
        </div>
      </div>
    </form>
  </div>
</div>
